import MonkeyMark from "./components/MonkeyMark";

export default function Navbar() {
    function AccountLinks() {
        const isLoggedIn = localStorage.getItem('isLoggedIn');

        if (isLoggedIn === "true") {
            const username = localStorage.getItem('username');
            return (
                <>
                    <li>
                        <span className="nav-welcome">🍌 {username}</span>
                    </li>
                    <li>
                        <a className="nav-link" href="/logout">Logout</a>
                    </li>
                </>
            );
        }

        return (
            <>
                <li>
                    <a className="nav-link" href="/createaccount">Sign up</a>
                </li>
                <li>
                    <a className="nav-link" href="/login">Login</a>
                </li>
            </>
        );
    }

    return (
        <nav className="nav">
            <div className="nav-inner">
                <a href="/" className="site-title">
                    <span className="site-logo"><MonkeyMark size={30} /></span>
                    Top Monkey
                </a>
                <ul className="nav-links">
                    <li>
                        <a className="nav-link" href="/play">Play</a>
                    </li>
                    <li>
                        <a className="nav-link" href="/leaderboard">Leaderboard</a>
                    </li>
                    <AccountLinks />
                </ul>
            </div>
        </nav>
    )
}
